import { GaugeChartSpec, gaugeChartSpecSchema } from '../../../core';
import { createVisualization } from '../../../plugin-system';
import { GaugeChartIcon } from './GaugeChartIcon';
import { GaugeChartOptionsEditorSettings } from './GaugeChartOptionsEditorSettings';
import { GaugeChartPanel } from './GaugeChartPanel';
import { createInitialGaugeChartSpec } from './gauge-chart-model';

export const GaugeChart = createVisualization(GaugeChartPanel, {
  dashboardConfig: {
    kind: 'GaugeChart',
    mapSpecToProps: (spec: GaugeChartSpec) => spec,
    mapPropsToSpec: (props) => props,
    panelOptionsEditorComponents: [
      {
        label: 'Settings',
        content: GaugeChartOptionsEditorSettings,
      },
    ],
    createInitialOptions: createInitialGaugeChartSpec,
    schema: gaugeChartSpecSchema,
    supportedDataType: 'SingleValue',
    icon: GaugeChartIcon,
  },
});

export type GaugeChartVizProps = React.ComponentProps<typeof GaugeChart.Viz>;
export type GaugeChartVizBaseProps = React.ComponentProps<typeof GaugeChart.VizBase>;
